import { useState, useEffect } from "react";

export const calculateTimeLeft = (targetTime) => {
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
  return targetTime - currentTime; // Time left in seconds
};

const useTimer = (targetTime) => {
  const [currentTime, setCurrentTime] = useState(Math.floor(Date.now() / 1000)); // Current time in seconds
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetTime)); // Calculate time left initially

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      setCurrentTime(now);
      setTimeLeft(targetTime - now); // Update time left
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [targetTime]);

  const formatTime = (seconds) => {
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts = [];

    if (days > 0) parts.push(`${days.toString()}D`);
    if (hours > 0) parts.push(`${hours.toString().padStart(2, "0")}H`);
    if (minutes > 0) parts.push(`${minutes.toString().padStart(2, "0")}M`);
    if (secs > 0) parts.push(`${secs.toString().padStart(2, "0")}S`);

    return parts.join(" : ");
  };

  return { timeLeft, formatTime };
};

export default useTimer;

// import { useState, useEffect } from "react";

// export const calculateTimeLeft = (targetTime) => {
//   const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
//   return targetTime - currentTime; // Time left in seconds
// };

// const useTimer = (targetTime, onTimeReached) => {
//   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetTime));

//   useEffect(() => {
//     const updateTimer = () => {
//       const newTimeLeft = calculateTimeLeft(targetTime);
//       setTimeLeft(newTimeLeft);

//       if (newTimeLeft === 0 && onTimeReached) {
//         onTimeReached();
//       }
//     };

//     updateTimer(); // Initial calculation

//     const interval = setInterval(updateTimer, 1000); // Update every second

//     const handleVisibilityChange = () => {
//       if (!document.hidden) {
//         updateTimer(); // Recalculate on tab reactivation
//       }
//     };

//     document.addEventListener("visibilitychange", handleVisibilityChange);

//     return () => {
//       clearInterval(interval); // Cleanup interval on unmount
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//     };
//   }, [targetTime, onTimeReached]);

//   const formatTime = (seconds) => {
//     if (seconds <= 0) return "00S";
//     const days = Math.floor(seconds / 86400);
//     const hours = Math.floor((seconds % 86400) / 3600);
//     const minutes = Math.floor((seconds % 3600) / 60);
//     const secs = seconds % 60;

//     const parts = [];
//     if (days > 0) parts.push(`${days.toString()}D`);
//     if (hours > 0) parts.push(`${hours.toString().padStart(2, "0")}H`);
//     if (minutes > 0) parts.push(`${minutes.toString().padStart(2, "0")}M`);
//     if (secs > 0) parts.push(`${secs.toString().padStart(2, "0")}S`);

//     return parts.join(" : ");
//   };

//   return { timeLeft, formatTime };
// };

// export default useTimer;
